import Wallet from "../components/wallet/Wallet";

export const API = {
  SEND_OTP: `/common/verify-otp/send-otp`,
  VERIFY_OTP: `/common/verify-otp/verify-otp`,
  FORGOT_PASSWORD: `/common/auth/forgot-password`,
  USER_SINGUP: `/website/user/sing-up`,
  USER_LOGIN: `/website/user/login`,
  CHECK_USER_EXITS: `/auth/check-exist`,
  GET_USER: `/website/get-user`,
  UPDATE_PROFILE: `/website/update-profile`,
  CHANGE_PASSWORD: `/website/user/change-password`,
  USER_ADDRESS: `/website/user-address`,
  MY_ACCOUNT: `/website/user/get-user`,
  MY_ACCOUNT_UPDATE: `/website/user/update-profile`,
  MY_PHOTO_UPDATE: `/common/auth/update-profile-photo`,
  UPDATE_PASSWORD: `/common/auth/update-password-wl`,
  PaymentOnline: `/website/product-order/payment-online`,
  GET_HOME_BANNERS: `/website/home/banner`,
  GET_ADVERTISMENT_BANNERS: `/website/advertisement-banner`,
  GET_COUPONS: `/website/home/all-coupons`,
  GET_Why_Choose_Us: `/website/home/all-whychooseus`,
  GET_What_We_Are: `/website/home/all-what_we_are`,
  GET_Welcome: `/website/home/all-welcome`,
  GET_What_Media_Do: `/website/home/all-what_media_do`,
  GET_Career: `/website/home/all-careers`,
  GET_Careers: `/website/home/all-careers`,
  CAREER_FORM: `/website/career/all-career-form`,
  CONTACT_US: `/website/contact/all-contact-us`,
  GET_Return_Policy: `/website/home/all-returnpolicy`,
  GET_POPULAR_STATUS: `/website/home/all-popular_product`,
  GET_SPECIAL_STATUS: `/website/home/all-special_product`,
  GET_HELP: `/website/home/all-help`,

  // GET_BLOG_CATEGORY: `/website/blog/all-blogcategory`,
  GET_BLOG: `/website/blog/all-blogs`,
  GET_BLOG_BY_ID: `/website/blog/all-blogsbyid`,
  // GET_LATEST_BLOG: `/website/blog/all-latestblog`,
  // GET_TOP_POST_STATUS: `/website/home/all-top_post_status`,

  REVIEW_RATING: `/website/rating-review`,
  AVG_REVIEW_RATING: `/website/rating-review/avg`,

  GET_ALL_COUNTRIES: `/common/masters/all-country`,
  GET_ALL_STATES: `/common/masters/all-state`,
  GET_ALL_CITIES: `/common/masters/all-city`,
  GET_ALL_PINCODES: `/common/masters/all-pincode`,
  GET_ALL_CATEGORIES: `/common/masters/all-p-category`,

  GET_ALL_SUB_CATEGORIES: `/common/masters/all-p-sub-category`,
  GET_ALL_CHILD_CATEGORIES: `/common/masters/all-p-child-category`,

  GET_Needs: `/common/masters/all-needs`,

  GET_OFFER_PRODUCT: `/website/home/all-offer-product`,
  GET_HOME_SHOP_AND_WATCH: `/website/home/all-home-watch-and-shop`,
  GET_Partners: `/common/masters/all-partners`,
  GET_SOCIAL_MEDIA: `/common/masters/all-socialmedia`,

  GET_ALL_PRODUCT_CATEGORIES: `/common/masters/all-p-category`,
  GET_ALL_PRODUCT_SUB_CATEGORIES: `/common/masters/all-p-sub-category`,
  GET_ALL_PRODUCT_GROUP_BY_SUB_CATEGORIES: `/website/product/all-product-groupby-category`,

  GET_ALL_PRODUCTS: `/website/product/all-products`,
  GET_ALL_OUR_PRODUCTS: `/website/product/seasonable-products`,
  GET_ALL_TIME_PRODUCTS: `/website/product/alltime-favs-products`,
  GET_PRODUCT: `/website/product`,
  GET_LINKED_PRODUCT: `/website/all-linked-product`,

  POST_REVIEW: `/website/rating-review`,
  GET_ALL_REVIEWS: `/website/rating-review`,
  GET_AVG_REVIEWS: `/website/rating-review/avg`,

  CART: `/website/cart`,
  GET_ALL_CART_WITHOUT_LOGIN: `/website/cart/without-login`,
  CHECk_ITEM_IN_CART: `/website/cart/check`,
  CART_QUANTITY: `/website/cart/quantity`,

  WISHLIST: `/website/wishlist`,
  Wallet: `/website/wallet`,
  CHECk_ITEM_IN_WISHLIST: `/website/wishlist/check`,

  ORDER: `/website/product-order`,
  ORDER_ADDRESS: `/website/user-address`,
  ORDER_CANCEL: `/website/product-order/product-order-cancel`,
  ORDER_RETURN: `/website//product-order/product-order-return`,

  GET_ALL_RESTAURANT_CATEGORY: `/common/masters/all-restaurant-categories`,
  GET_ALL_CANCEL_REASONS: `/common/masters/all-cancel-reasons`,
  GET_ALL_RETURN_REASONS: `/common/masters/all-return-reasons`,

  GET_ALL_PAYMENT_METHOD: `/common/masters/all-payment-method`,
  GET_ALL_ADDRESS_TYPE: `/common/masters/all-address-type`,

  GET_INDUSTRY: `/common/masters/all-industry`,

  GET_DEPARTMENT: `/common/masters/all-department`,
  GET_COMPANY_SIZE: `/common/masters/all-companysize`,
  GET_APP_SETUP: `/common/masters/app-setup`,

  COUPON_APPLYED: `/website/coupons/valid`,
  COUPON: `/website/coupons`,

  ORDER_CALCULATION: `/website/product-order/calculate`,

  ORDER_STATUS: `/common/masters/all-order-status`,
  SOCIAL_LINK: `/common/masters/social-links`,
  BENEFIT: `/website/home/benefits`,

  GET_SHAPE: `/common/masters/all-shape`,

  EXCHANGE_RATE: `/common/masters/exchange-rate`,
  ALL_CURRENCY: `/common/masters/all-currency`,

  GET_ABOUTUS_CONTENT: `/website/about-us/content`,
  GET_ABOUTUS: `/website/about-us`,
  GET_ACH_AND_ACK: "/website/about-us/achievements",
  GET_FOUNDING_FARMERS: "/website/about-us/fouding-farmers",
  CONTACT_US_FORM: `/website/contact-us`,

  GET_Privacy_Policy: `/website/home/all-privacypolicy`,
  GET_TERM_CONDITION: `/website/home/all-termsandconditions`,
  GET_Cancellation_and_Return : `/website/home/all-cancellationandreturns`,

  GET_SUBFAQ: `/common/masters/all-subfaq`,
  GET_FAQCATE: `/common/masters/all-subfaq`,
  GET_FAQ: `/common/masters/all-faq`,

  CATEGORY_WISE_PRODUCTS: `/website/product/all-product-groupby-category`,
};
